import React from "react";
import { isZh } from "../../utils/language";

export default function PreRegConfirmSection({
  baseData,
  registrationRole,
  setStep,
  submitting,
  handleSubmit,
  fields,
  customValues,
}) {

  const visibleFields =
    (fields || []).filter((f) => {

      if (f.scope === "all") {
        return true;
      }

      return (
        f.scope === registrationRole
      );
    });

  const roleLabel =
    registrationRole === "petugas"
      ? (
        isZh()
          ? "辦事人員"
          : "Petugas"
      )
      : (
        isZh()
          ? "班員"
          : "Peserta"
      );

  return (
    <>

      <div className="confirm-card">

        <div className="confirm-section-title">
          {isZh()
            ? "基本資料"
            : "Data Dasar"}
        </div>

        <ConfirmRow
          label={
            isZh()
              ? "姓名"
              : "Nama"
          }
          value={baseData.name}
        />

        <ConfirmRow
          label={
            isZh()
              ? "身份"
              : "Role"
          }
          value={roleLabel}
        />

        {baseData.gender && (
          <ConfirmRow
            label="Gender"
            value={baseData.gender}
          />
        )}

        {baseData.phoneNumber && (
          <ConfirmRow
            label={
              isZh()
                ? "電話"
                : "No. Telp"
            }
            value={baseData.phoneNumber}
          />
        )}

        {baseData.email && (
          <ConfirmRow
            label="Email"
            value={baseData.email}
          />
        )}

        {baseData.address && (
          <ConfirmRow
            label={
              isZh()
                ? "地址"
                : "Alamat"
            }
            value={baseData.address}
          />
        )}

        {baseData.fotang && (
          <ConfirmRow
            label={
              isZh()
                ? "佛堂"
                : "Fotang"
            }
            value={baseData.fotang}
          />
        )}

      </div>

      {visibleFields.length > 0 && (

        <div className="confirm-card">

          <div className="confirm-section-title">
            {isZh()
              ? "附加欄位"
              : "Field Tambahan"}
          </div>

          {visibleFields.map((f) => {

            const label =
              isZh()
                ? (
                  f.labelZh ||
                  f.labelId
                )
                : (
                  f.labelId ||
                  f.labelZh
                );

            const value =
              customValues?.[f.id];

            return (
              <ConfirmRow
                key={f.id}
                label={label}
                value={formatValue(value)}
              />
            );
          })}

        </div>
      )}

      <div className="bottom-actions">

        <button
          type="button"
          className="btn-secondary"
          onClick={() => setStep(2)}
        >
          {isZh()
            ? "返回"
            : "Kembali"}
        </button>

        <button
          type="button"
          className="btn-primary"
          disabled={submitting}
          onClick={handleSubmit}
        >
          {submitting
            ? "..."
            : (
              isZh()
                ? "提交"
                : "Submit"
            )}
        </button>

      </div>

      <style>{`

        .confirm-card{
          border:1px solid #dbe3ef;
          border-radius:1rem;
          padding:1rem;
          background:#fff;
          margin-bottom:1rem;
        }

        .confirm-section-title{
          font-size:1rem;
          font-weight:700;
          margin-bottom:1rem;
        }

        .confirm-row{
          display:grid;
          grid-template-columns:12rem 1fr;
          gap:1rem;
          padding:0.8rem 0;
          border-top:1px solid #f1f5f9;
        }

        .confirm-row:first-of-type{
          border-top:none;
          padding-top:0;
        }

        .confirm-label{
          font-size:0.9rem;
          font-weight:600;
          color:#475569;
        }

        .confirm-value{
          font-size:0.92rem;
          white-space:pre-wrap;
          word-break:break-word;
        }

        .bottom-actions{
          display:flex;
          justify-content:space-between;
          margin-top:1.5rem;
        }

        .btn-primary{
          border:none;
          background:#2563eb;
          color:#fff;
          border-radius:0.7rem;
          padding:0.75rem 1.2rem;
          font-size:0.9rem;
          font-weight:600;
          cursor:pointer;
        }

        .btn-primary:disabled{
          opacity:0.6;
          cursor:not-allowed;
        }

        .btn-secondary{
          border:1px solid #cbd5e1;
          background:#fff;
          color:#111827;
          border-radius:0.7rem;
          padding:0.75rem 1.2rem;
          font-size:0.9rem;
          font-weight:600;
          cursor:pointer;
        }

        @media (max-width:640px){

          .confirm-row{
            grid-template-columns:1fr;
            gap:0.35rem;
          }

        }

      `}</style>

    </>
  );
}

function ConfirmRow({
  label,
  value,
}) {

  if (
    value === undefined ||
    value === null ||
    value === ""
  ) {
    return null;
  }

  return (
    <div className="confirm-row">

      <div className="confirm-label">
        {label}
      </div>

      <div className="confirm-value">
        {value}
      </div>

    </div>
  );
}

function formatValue(value) {

  if (
    value === undefined ||
    value === null ||
    value === ""
  ) {
    return "-";
  }

  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return `${value}`;
}